import dayjs, { type Dayjs } from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

import { AppConfig } from '@/Ship/Configs/AppConfig'

dayjs.extend(utc)
dayjs.extend(timezone)

/**
 * Час порталу: дати показуються за `AppConfig.timezone` (Київ), а не за поясом браузера,
 * так само як у картці запису (Core DateFieldStrategy). Бекенд зберігає київський час.
 */
export const APP_TIMEZONE: string = AppConfig.timezone ?? 'Europe/Kyiv'

/** Рядок із явним поясом: `…+03:00`, `…+0300`, `…Z` */
const HAS_OFFSET = /(?:[+-]\d{2}:?\d{2}|Z)$/i

/** Момент часу з API → dayjs у поясі порталу; рядок без поясу — як є (вже місцевий час) */
const toAppDayjs = (value: string): Dayjs | null => {
    const date = HAS_OFFSET.test(value) ? dayjs(value).tz(APP_TIMEZONE) : dayjs(value)
    return date.isValid() ? date : null
}

/** Форматує дату з API в поясі порталу; порожнє або невалідне → null */
export const formatAppDate = (value: unknown, format: string): string | null => {
    if (typeof value !== 'string' || value === '') return null
    return toAppDayjs(value)?.format(format) ?? null
}

/**
 * Момент часу з поясом → «настінний» час порталу без поясу (`2026-09-30T21:08:00`).
 * Core форматує дати таблиці через `dayjs(value)` у поясі браузера; рядок без поясу
 * dayjs розбирає як місцевий час, тож після цього таблиця показує київський час
 * у будь-якому поясі. Інші значення (дата без часу, не рядок) повертає без змін.
 */
export const toAppWallClock = <T>(value: T): T | string => {
    if (typeof value !== 'string' || !HAS_OFFSET.test(value)) return value
    return toAppDayjs(value)?.format('YYYY-MM-DDTHH:mm:ss') ?? value
}
